import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-[var(--radius-sm)] px-2 py-0.5 text-xs font-medium font-sans border transition-colors",
  {
    variants: {
      variant: {
        // Neutral - counts, tags, labels
        default:
          "bg-muted text-foreground border-transparent",

        // Brand - plan badges, highlights
        primary:
          "bg-primary-subtle text-primary border-[hsl(var(--brand-200))]",

        // Success - active, confirmed, complete
        success:
          "bg-success-bg text-success-fg border-success-border",

        // Warning - caution, attention needed
        warning:
          "bg-warning-bg text-warning-fg border-warning-border",

        // Destructive - errors, over-limit, removed
        destructive:
          "bg-destructive-bg text-destructive-fg border-destructive-border",

        // Info - permissions, informational
        info:
          "bg-info-bg text-info-fg border-info-border",

        // Outline - subtle, secondary label
        outline:
          "bg-transparent text-foreground border-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
